module.exports = __webpack_public_path__ + "static/img/mo_btn1.5a0a2c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/mo_btn1.png
// module id = dKD+
// module chunks = 7